import React, { useState, useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import { base_url } from "../../Global";

const UserChart = () => {
  const [users, setUsers] = useState([]);
  const chartRef = useRef(null);
  const canvasRef = useRef(null); // ✅ use ref instead of getElementById

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(base_url + "/auth/allProfile");
        const userData = await response.json();
        setUsers(userData?.users);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!users || users.length === 0) return;
    renderChart();

    // ✅ Cleanup on unmount to avoid canvas reuse errors
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
  }, [users]);

  const countUsersByMonth = () => {
    const currentDate = new Date();
    const monthlyCounts = Array(6).fill(0);
    users?.forEach((user) => {
      const createdAtDate = new Date(user.createdAt);
      const diffMonths =
        (currentDate.getFullYear() - createdAtDate.getFullYear()) * 12 +
        (currentDate.getMonth() - createdAtDate.getMonth());
      if (diffMonths < 6) {
        monthlyCounts[5 - diffMonths]++;
      }
    });
    return monthlyCounts;
  };

  const getMonthName = (monthIndex) => {
    const currentDate = new Date();
    const targetDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - monthIndex,
      1
    );
    const monthNames = [
      "January", "February", "March", "April",
      "May", "June", "July", "August",
      "September", "October", "November", "December",
    ];
    return monthNames[targetDate.getMonth()];
  };

  const renderChart = () => {
    const monthlyCounts = countUsersByMonth();

    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }

    if (!canvasRef.current) return;

    chartRef.current = new Chart(canvasRef.current, {
      type: "bar",
      data: {
        labels: [
          getMonthName(5), getMonthName(4), getMonthName(3),
          getMonthName(2), getMonthName(1), getMonthName(0),
        ],
        datasets: [
          {
            label: "User Registrations",
            data: monthlyCounts,
            backgroundColor: "rgba(54, 162, 235, 0.5)",
            borderColor: "rgba(54, 162, 235, 1)",
            borderWidth: 1,
          },
        ],
      },
      options: {
        responsive: true,        // ✅ chart resizes with container
        maintainAspectRatio: true,
        plugins: {
          legend: { position: "top" },
        },
        scales: {
          y: {
            beginAtZero: true,
            title: { display: true, text: "Number of Users" },
          },
          x: {
            title: { display: true, text: "Month" },
          },
        },
      },
    });
  };

  return (
    <div className="
      flex-1
      w-full lg:min-w-[20rem]
      rounded-[18px]
      mt-5
      bg-gray-100
      shadow-[0px_0px_13.71px_rgba(0,_0,_0,_0.15)]
      flex flex-col
      items-start justify-start
      p-[1rem] sm:p-[1.5rem]
      gap-4
      box-border
      relative z-[1]
    ">
      <div className="flex flex-row items-center justify-between w-full px-2">
        <h2 className="text-lg sm:text-xl font-semibold">User Registration</h2>
        <h2 className="text-lg sm:text-xl font-bold">{users?.length ?? 0}</h2>
      </div>

      {/* ✅ Responsive canvas wrapper */}
      <div className="w-full overflow-hidden">
        <canvas ref={canvasRef}></canvas>
      </div>
    </div>
  );
};

export default UserChart;